import { useState } from "react"
import { IconButton, Menu, MenuItem, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGear, faFileAlt } from "@fortawesome/pro-solid-svg-icons"

const MUX_STREAM_BASE_URL = "https://stream.mux.com"

// Downloads a VTT transcript file from Mux
const downloadTranscript = async (playbackId: string, trackId: string) => {
  const url = `${MUX_STREAM_BASE_URL}/${playbackId}/text/${trackId}.vtt`
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = blobUrl
    link.download = `transcript-${trackId}.vtt`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error("Failed to download transcript:", error)
  }
}

interface MuxSettingsMenuProps {
  playbackId: string
  subtitleTrackId: string
}

export const MuxSettingsMenu: React.FC<MuxSettingsMenuProps> = ({
  playbackId,
  subtitleTrackId
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(menuAnchorEl)

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setMenuAnchorEl(null)
  }

  const handleDownloadTranscript = () => {
    downloadTranscript(playbackId, subtitleTrackId)
    handleCloseMenu()
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpenMenu}
        sx={{
          position: "absolute",
          bottom: 6,
          right: 65,
          zIndex: 20,
          padding: "6px",
          color: "white",
          pointerEvents: "auto",
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.2)"
          }
        }}
      >
        <FontAwesomeIcon
          icon={faGear}
          style={{ color: "white", fontSize: "14px" }}
        />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={isMenuOpen}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
      >
        <MenuItem
          dense
          onClick={handleDownloadTranscript}
          sx={{ gap: 1.5, py: 0, minHeight: "auto" }}
        >
          <FontAwesomeIcon icon={faFileAlt} style={{ fontSize: "14px" }} />
          <Typography style={{ fontSize: "14px" }}>
            Download Transcript
          </Typography>
        </MenuItem>
      </Menu>
    </>
  )
}
